/* Local reading tools only: no network, storage, tracking or checkout access. */
(function () {
  'use strict';
  function initialize() {
    var story = document.getElementById('df-b2b-story');
    if (!story || story.dataset.dfbReady === 'true') return;
    story.dataset.dfbReady = 'true';
    var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var planner = story.querySelector('[data-dfb-planner]');
    if (planner) {
      var tiers = { 12: 1590, 24: 1490, 48: 1290, 96: 1190, 192: 1090 };
      var quantity = 48;
      var buttons = planner.querySelectorAll('[data-dfb-quantity]');
      var shipping = planner.querySelector('[data-dfb-us-delivery]');
      function updatePrice() {
        if (!Object.prototype.hasOwnProperty.call(tiers, quantity)) return;
        var products = tiers[quantity] * quantity;
        var delivery = shipping.checked ? quantity * 300 : 0;
        buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.dfbQuantity) === quantity)); });
        planner.querySelectorAll('[data-dfb-tier-row]').forEach(function (row) { row.dataset.selected = String(Number(row.dataset.dfbTierRow) === quantity); });
        planner.querySelector('[data-dfb-unit]').textContent = money.format(tiers[quantity] / 100) + ' per complete set · ' + quantity + ' decks';
        planner.querySelector('[data-dfb-products]').textContent = money.format(products / 100);
        planner.querySelector('[data-dfb-delivery-row]').hidden = !shipping.checked;
        planner.querySelector('[data-dfb-delivery]').textContent = money.format(delivery / 100);
        planner.querySelector('[data-dfb-total]').textContent = money.format((products + delivery) / 100);
        planner.querySelector('[data-dfb-total-label]').textContent = shipping.checked ? 'Products + US delivery' : 'Products total';
        planner.querySelector('[data-dfb-scope]').textContent = shipping.checked ? 'Includes the displayed US delivery estimate. Any selected preparation and applicable taxes or import charges need confirmation for your order.' : 'Delivery is separate. Any selected preparation and applicable taxes or import charges need confirmation for your order.';
      }
      buttons.forEach(function (button) {
        button.addEventListener('click', function () { quantity = Number(button.dataset.dfbQuantity); updatePrice(); });
      });
      shipping.addEventListener('change', updatePrice);
      updatePrice();
    }
    var checklist = story.querySelector('[data-dfb-checklist]');
    if (checklist) {
      var items = checklist.querySelectorAll('[data-dfb-check]');
      var status = checklist.querySelector('[data-dfb-check-status]');
      var bar = checklist.querySelector('[data-dfb-check-progress]');
      function updateChecklist() {
        var checked = Array.from(items).filter(function (item) { return item.checked; }).length;
        status.textContent = checked + ' of ' + items.length + ' checked' + (checked === items.length ? ' — review your final proof before production approval.' : '');
        bar.style.width = String((checked / items.length) * 100) + '%';
      }
      items.forEach(function (item) { item.addEventListener('change', updateChecklist); });
      checklist.querySelector('[data-dfb-check-reset]').addEventListener('click', function () {
        items.forEach(function (item) { item.checked = false; });
        updateChecklist();
      });
      updateChecklist();
    }
    // Native disclosure content is exposed in print and restored afterwards.
    var disclosures = [];
    window.addEventListener('beforeprint', function () {
      disclosures = Array.from(story.querySelectorAll('details')).map(function (detail) { return { element: detail, open: detail.open }; });
      disclosures.forEach(function (entry) { entry.element.open = true; });
    });
    window.addEventListener('afterprint', function () {
      disclosures.forEach(function (entry) { entry.element.open = entry.open; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
}());
